import EditorMenuBarButton from 'automation-ui-canvas/components/flow-header/menu-bar/EditorMenuBarButton';
import styled from 'styled-components';
import { useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledDropdownContainer = styled.div.withConfig({
  displayName: "EditorQuickOptionButton__StyledDropdownContainer",
  componentId: "u4qng7-0"
})([""]);
export const EditorQuickOptionButton = ({
  option,
  flow,
  onOptionClick
}) => {
  const [open, setOpen] = useState(false);
  return /*#__PURE__*/_jsx(EditorMenuBarButton, {
    id: option.id,
    open: open,
    options: option.options,
    title: option.getLabel({
      objectTypeId: flow.objectTypeId
    }),
    onMouseEnter: () => {},
    onOpenChange: ({
      value
    }) => setOpen(value),
    objectTypeId: flow.objectTypeId,
    onOptionClick: clickedOption => {
      onOptionClick(clickedOption, {
        isExtraOption: true
      });
    },
    onClick: () => {
      onOptionClick(option, {
        isExtraOption: true
      });
    },
    flow: flow,
    Container: StyledDropdownContainer,
    dropdownProps: {
      buttonSize: 'extra-small'
    }
  }, option.id);
};